<template>
  <div class="ditch">
        <!-- <input-select @getSelect="setData" :elName="'渠道组类型'" :txt="ajaxData.ajaxType" :propType="{type:'type'}" :hint="'请输入渠道组类型'" :list="list"></input-select> -->
        <div class="inputSelect">
            <span>*</span>
            <p>渠道媒介类型</p>
            <div class="input-box">
                <i class="icon iconfont icon-zheng-triangle" :class="{'rotate-icon':isShowSelect}"></i>
                <div class="copyModel" @click.stop="isShowSelect = !isShowSelect">{{type}}</div>
                <ul :class="{'show-select':isShowSelect}" @click.stop>
                    <li v-for="(val,key,index) in list" :key="index" @click="bindSelect($event,{val:val,key:key})">{{val}}</li>
                </ul>
            </div>
            <i>下拉选择渠道媒介类型</i>
        </div>
        <div class="inputText">
            <span>*</span>
            <p>渠道媒介名称</p>
            <div class="input-box">
                <input type="text" name="name" v-model="name" placeholder="请输入渠道组名称">
            </div>
            <i>中英文,如 知乎软文 (该媒介的所属媒介名称)</i>
        </div>
        <div class="inputText">
            <span>*</span>
            <p>渠道媒介标识</p>
            <div class="input-box">
                <input type="text" name="name" v-model="icon" placeholder="请输入渠道组标识">
            </div>
            <i>英文,如 zhihu (标识具有唯一性 不能重复添加)</i>
        </div>
        <div class="btn-box">
            <input-submit @getSubmit="bindCreate" :txt="'提交'" :color="'#ffcc00'"></input-submit>
            <input-submit @getSubmit="bindReturn" :txt="'返回'" :color="'deepskyblue'"></input-submit>
        </div>
  </div>
</template>

<script>
    import inputSubmit from "./from/inputSubmit"
    import bus from "./js/a.js"
    import {mapActions} from "vuex"
    export default {
        name:"ditch",
        props:["searchUrl","busName","popu","isId"],
        data(){
            return {
                ajaxId:0,
                name:"",
                type:"请选择",
                icon:"",
                ajaxType:0,
                list:{},
                isShowSelect:false,
                isNew:false
            }
        },
        mounted(){
            let _this = this;
            document.body.addEventListener('click',()=>{
                this.isShowSelect=false;
            })
            bus.$on('bindEmpty',function () {
                _this.name="";
                _this.type="请选择";
                _this.icon="";
                _this.ajaxType=0;
                _this.ajaxId = null;
            })
        },
        watch:{
            "popu":function(val){
                this.list = val;
            },
            "isId":function(val){
                if(val){
                    $.ajax({
                        url:this.searchUrl+"getEditInfo",
                        headers: {
                            'Auth-Token' : localStorage.getItem("token")
                        },
                        type:"POST",
                        data:{id:val},
                        dataType:"JSON",
                        success:(res)=>{
                            let data = res.data;
                            this.ajaxId = val;
                            this.name= data.medium[0].name; //名称
                            this.ajaxType = data.medium[0].type; //类型索引(s数字)
                            this.type = this.list[data.medium[0].type]; //类型索引(文字)
                            this.icon = data.medium[0].identifying; //标识
                        }
                    })
                }else{
                    this.name="";
                    this.type="请选择";
                    this.icon="";
                    this.ajaxType=0;
                    this.ajaxId = null;
                }
            }
        },
        methods:{
            ...mapActions(['setHint']),
            // 发送ajax请求
            bindCreate(){
                if(!localStorage.getItem("token")){
                    this.$router.push({path:"/"});
                    return ;
                }
                
                if(!this.ajaxType){
                    this.setHint({txt:"请选择渠道媒介类型",className:"hint-error"})
                    return ;
                }else if(!this.name){
                    this.setHint({txt:"请输入渠道媒介名称",className:"hint-error"})
                    return ;
                }else if(!this.icon){
                    this.setHint({txt:"请输入渠道媒介标识",className:"hint-error"})
                    return ;
                }
                let _this = this;
                let _data = {name:this.name,type:this.ajaxType,identifying:this.icon}
                if(this.ajaxId){
                    _data.id = this.ajaxId;
                }
                
                $.ajax({
                    url:_this.searchUrl+"saveData",
                    headers: {
                        'Auth-Token' : localStorage.getItem("token")
                    },
                    type:"POST",
                    data:_data,
                    dataType:"JSON",
                    success:(res)=>{
                        if(res.status == 1){
                            this.ajaxId = 0;
                            this.bindReturn(true)
                            this.$emit("getChild",2)
                            this.setHint({txt:res.msg,className:"hint-success"})
                        }else{
                            this.setHint({txt:res.msg,className:"hint-error"})
                        }
                        
                    }
                })
            },
            // 返回
            bindReturn(val){
                this.$emit("getChild",1)
            },
            // select 选择
            bindSelect(event,val){
                this.ajaxType = val.key;
                this.type = val.val;
                this.isShowSelect = false;
            }
        },
        components:{
            // inputText:inputText,
            inputSubmit:inputSubmit,
            // inputSelect:inputSelect,
            // inputRadio:inputRadio
        }
    }
</script>

<style scoped>
.btn-box {
    display: flex;
    justify-content: space-between;
    width: 460px;
    text-align: left;
    padding-left: 140px;
}
</style>




// WEBPACK FOOTER //
// src/components/main/ditchMedium.vue